export default __webpack_public_path__ + "static/media/premiumicon.7f1b39f1.svg";